const categoria = (DataBase, Datatype) => {
	const Categoria = DataBase.new(
		{
			nome: Datatype.STRING,
			descricao: Datatype.STRING,
		},
		{
			tracked: true,
			dateLogs: true,
			softDelete: true,
			collection: "categoria",
			model: "Categoria",
		}
	);

	return Categoria;
};

export default categoria;
